import src from "IMAGE";
export default { src, width: 993, height: 272, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPklEQVR42jWKOQrAMAwEpSKNJa0OFykC8f9/aWFwsewwDDEzqeqTmaOqYGaz90bE5+4/3QDAaAERmc0n6F8bZgwDYMzEAG8AAAAASUVORK5CYII="};
